module.exports = __webpack_public_path__ + "img/jmb.714be012.svg";